import AuthSideNav from './AuthSideNav.component';
export default AuthSideNav;